var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 720,
    viewBox: "0 0 1280 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13315_22707)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 720,
    fill: "url(#paint0_radial_13315_22707)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1234.29 6.81177e-05L1006.26 7.80853e-05L736.418 213.01L910.432 8.22741e-05L788.995 8.75823e-05L678.337 188.031L700.347 9.14572e-05L582.366 9.66143e-05L604.521 188.031L493.791 0.000100486L372.37 0.000105794L545.294 211.01L262.452 0.000110598L51.4198 0.000119823L491.206 263.657L-3.0753e-05 46.7653L-2.43297e-05 170.526L467.403 324.38L-1.86733e-05 284.523L-1.25514e-05 442.771L468.403 399.108L-6.71247e-06 554.591L-2.62283e-07 669.312L493.206 456.84L51.4198 718.913L262.452 718.913L547.294 509.478L372.37 718.913L493.791 718.913L604.247 531.457L582.366 718.913L700.347 718.913L678.336 531.457L788.995 718.913L910.432 718.913L734.418 508.478L1006.26 718.913L1234.29 718.913L786.507 455.84L1280 669.312L1280 554.591L810.309 399.108L1280 442.771L1280 284.523L811.309 324.38L1280 170.526L1280 46.7653L788.507 265.657L1234.29 6.81177e-05Z",
    fill: "url(#paint1_radial_13315_22707)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_13315_22707",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(640 360) rotate(90) scale(360 640)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1966FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A337F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_13315_22707",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(693.416 362.2) rotate(-90) scale(770.878 763.974)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044CC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13315_22707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 720,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBackground);
export default __webpack_public_path__ + "static/media/default-background.7db49c0d.svg";
export { ForwardRef as ReactComponent };